import React from "react";
import "../../styles/sevicesPages/blisterPackagingStyle.css";
import "../../styles/app.css";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Footer from "../../components/footer";
import Navbar from "../../components/navbar";

const BlisterPackaging = () => {
    useScrollAnimation();

  return (
    <>
    <Navbar />
    <section className="blister-packaging">

      <div className="bp-hero slide-down">
        <div className="bp-hero-text fade-in">
          <h1>Blister Packaging</h1>
          <p>Simplify your medication routine with organized blister packaging.</p>
        </div>
        <div className="bp-hero-image slide-right">
          <img
            src="../assets/blister-pack.jpg"
            alt="Blister Packaging"
          />
        </div>
      </div>

      <div className="bp-info fade-in-delay">
        <h2>Why Choose Blister Packaging?</h2>
        <ul>
          <li>Easy daily dose organization</li>
          <li>Reduces medication errors</li>
          <li>Great for seniors and caregivers</li>
          <li>Weekly planning & travel convenience</li>
        </ul>
      </div>

      {/* <div className="bp-pricing slide-up-delay-1">
        <h2>Pricing & Discounts</h2>

        <div className="bp-pricing-card">
          <h3>Starter Pack</h3>
          <p>Up to 7 days</p>
          <p><strong>$15</strong></p>
        </div>

        <div className="bp-pricing-card">
          <h3>Monthly Pack</h3>
          <p>Up to 30 days</p>
          <p><strong>$40</strong></p>
        </div>

        <div className="bp-pricing-card">
          <h3>Family Pack</h3>
          <p>Up to 60 days</p>
          <p><strong>$70</strong></p>
        </div>

        <p className="bp-discount fade-in-delay-2">
          💡 <strong>10% OFF</strong> when you enroll in recurring blister packaging!
        </p>
      </div>

      <div className="bp-cta fade-in-delay-3">
        <a href="/book-appointment" className="btn-primary">Request Blister Packaging</a>
      </div> */}
    </section>
    <Footer/>
    </>
  );
};

export default BlisterPackaging;
